import { map } from 'd3-collection';
import { Component, h } from 'preact';
import { intcomma } from 'journalize';

import Candidate from './Candidate';
import OtherCandidate from './OtherCandidate';
import ResultsMap from './ResultsMap';

import { DEMOCRAT, NEUTRAL, REPUBLICAN } from '../utils/primary-colors';

import capitalize from '../utils/capitalize';
import sumValues from '../utils/sum-values';

class Contest extends Component {
  constructor() {
    super();

    this.state = { viewAllContests: false };

    this.onViewableToggle = this.onViewableToggle.bind(this);
    this.candidateColorMap = map();
  }

  onViewableToggle() {
    this.setState(prevState => ({
      viewAllContests: !prevState.viewAllContests,
    }));
  }

  updateColorMap(candidates, party) {
    const colors = party === 'democrat' ? DEMOCRAT : REPUBLICAN;
    const numColors = colors.length;

    candidates.forEach((candidate, idx) => {
      this.candidateColorMap.set(
        candidate.id,
        numColors < idx + 1 ? NEUTRAL : colors[idx]
      );
    });
  }

  componentWillReceiveProps(nextProps) {
    const currentProps = this.props;

    if (nextProps.contest.id !== currentProps.contest.id) {
      const { candidates, party } = nextProps.contest;

      this.updateColorMap(candidates, party);
    }
  }

  componentWillMount() {
    const { candidates, party } = this.props.contest;

    this.updateColorMap(candidates, party);
  }

  render(
    { contest, includeContestCaptionDetail, shouldIncludeMap = false, year },
    { viewAllContests }
  ) {
    const shouldDisplayResult =
      contest.is_called && contest.result !== 'not called';
    const totalVotes = sumValues(contest.candidates, 'votes');
    const isStatewide = contest.division_type === 'statewide';
    const partyDisplay =
      contest.party === 'democrat' ? 'democratic' : 'republican';

    const upperPartyDisplay = capitalize(partyDisplay);
    const captionElection = year
      ? `${year} ${upperPartyDisplay} Primary`
      : `${upperPartyDisplay} Primary`;

    let caption;

    if (includeContestCaptionDetail) {
      if (isStatewide) {
        caption = `${contest.office} - ${captionElection}`;
      } else {
        caption = `${contest.office}, ${capitalize(contest.division_type)} ${
          contest.district
        } - ${captionElection}`;
      }
    } else {
      caption = captionElection;
    }

    const numberOfCandidates = contest.candidates.length;
    const raceIsUncontested = numberOfCandidates === 1;

    return (
      <div class="contest">
        <div class="contest__results">
          <table class="contest__candidates">
            <caption class="contest__caption">
              <p class="contest__caption-title">{caption}</p>
            </caption>
            <thead>
              <tr>
                <th class="contest__candidate-header" colspan="2">
                  Candidate
                </th>
                <th class="contest__candidate-header contest__candidate-header--numeric">
                  Votes
                </th>
                <th class="contest__candidate-header contest__candidate-header--numeric">
                  Pct.<span class="candidate__pct-symbol">%</span>
                </th>
              </tr>
            </thead>
            <tbody>
              {shouldDisplayResult && (
                <tr class="contest__called-row">
                  <td colspan="4">{contest.result}</td>
                </tr>
              )}
              {contest.candidates.map((candidate, idx) => {
                return (
                  <Candidate
                    key={candidate.id}
                    candidate={candidate}
                    color={this.candidateColorMap.get(candidate.id)}
                    ignoreColor={!shouldIncludeMap || !isStatewide}
                    totalVotes={totalVotes}
                    raceIsCalled={contest.is_called}
                    raceIsUncontested={raceIsUncontested}
                    isViewable={totalVotes <= 0 || viewAllContests || idx < 4}
                  />
                );
              })}
              {numberOfCandidates > 4 &&
                totalVotes > 0 && (
                  <OtherCandidate
                    isViewable={!viewAllContests}
                    party={partyDisplay}
                    votes={sumValues(
                      contest.candidates
                        .slice(4)
                        .filter(candidate => !candidate.is_winner),
                      'votes'
                    )}
                    totalVotes={totalVotes}
                    candidateCount={numberOfCandidates - 4}
                    onClick={this.onViewableToggle}
                  />
                )}
            </tbody>
          </table>
          <div class="contest__metrics">
            {numberOfCandidates > 4 &&
              viewAllContests && (
                <button
                  class="contest__candidates-toggle"
                  onClick={this.onViewableToggle}
                >
                  View fewer candidates{' '}
                  <svg class="icon icon-angle-up">
                    <use xlinkHref="#icon-angle-up" />
                  </svg>
                </button>
              )}
            <p class="contest__precincts">
              {raceIsUncontested
                ? 'No totals reported in uncontested races'
                : `${intcomma(contest.precincts_reporting)} of ${intcomma(
                    contest.total_precincts
                  )} precincts reporting (${contest.precincts_reporting_percent.toFixed(
                    1
                  )}%)`}
            </p>
          </div>
        </div>
        {shouldIncludeMap &&
          isStatewide &&
          !raceIsUncontested && (
            <ResultsMap
              contest={contest}
              candidates={contest.candidates}
              counties={contest.counties}
              colorMap={this.candidateColorMap}
            />
          )}
      </div>
    );
  }
}

export default Contest;



// WEBPACK FOOTER //
// ./componentsV2/Contest.js